import React, {useState, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import './Post.css';
import arrow from "../../../assets/images/grayarrow.gif";
import {getDifferenceBetweenDates} from "../../../Utils/utils";
import * as actions from "../../../store/actions";

const Post = (props) => {

    const [upVote, setUpVote] = useState(false);

    const token = useSelector(state => state.auth.token)
    const isAuth = useSelector(state => state.auth.token !== null)
    const userId = useSelector(state => state.auth.userId)

    useEffect(() => {
        if(props.upVoteBy) {
            const vote = props.upVoteBy[userId] === 1
            setUpVote(vote)
        }
    }, [props.upVoteBy, userId])

    const dispatch = useDispatch()

    const onToggleUpVote = (event) => {
        event.preventDefault()
        if (!isAuth) {
            const pathname = props.location.pathname.substring(1)
            props.history.push({
                pathname: '/auth',
                search: pathname === "" ? "" : "?goto=" + pathname + props.location.search
            })
            return;
        }
        dispatch(actions.postToggleUpVote(props.id, props.postId, props.userId, userId, props.points, upVote, token))
        setUpVote(flag => !flag)
    }

    return (
        <tbody className="Post">
        <tr>
            <td><span className="rank">{!props.showId ? null : props.id ? props.id + "." : null}</span></td>
            <td title="upvote">
                <div onClick={onToggleUpVote} style={{visibility: !upVote ? "visible" : "hidden"}}>
                    <img src={arrow} alt=""/>
                </div>
            </td>
            <td>
                        <span className="title">
                            <a href={props.url} target="_blank" rel="noreferrer">
                                {props.title}
                            </a>
                        </span>
                &nbsp;
                <span className="domain"> <a href={"//" + props.domain} target="_blank"
                                             rel="noreferrer">({props.domain})</a></span>
            </td>
        </tr>
        <tr>
            <td colSpan="2"/>
            <td>
                      <span className="sub_text">
                        {props.points} points by&nbsp;
                          <Link
                              to={{
                                  pathname: "/user",
                                  search: "?userId=" + props.userId
                              }}
                          >
                              {props.author}
                          </Link>
                          &nbsp;
                          {getDifferenceBetweenDates(new Date(props.createdOn), new Date())}
                          &nbsp;|&nbsp;
                          {upVote ? (
                              <>
                                  <a href={window.location} onClick={onToggleUpVote}>unvote</a>
                                  &nbsp;|&nbsp;
                              </>
                          ) : null}
                          hide &nbsp;|&nbsp;
                          <Link
                              to={{
                                  pathname: "/post",
                                  search: "?id=" + props.postId
                                  //TODO Fix error on state: {postData: {...props}}
                              }}
                          >
                              {props.comments} comments
                          </Link>
                      </span>
            </td>
        </tr>
        <tr style={{height: "5px"}}/>
        </tbody>
    )
}

export default withRouter(Post);